





import Vue from 'vue'
export default Vue.extend({
  name: 'HomeNewContent',
  components: { },
  props:
  {
    contido: {
      type: String,
      required: false
    }
  },
  computed: {
    contidoHtml (): string {
      const parseddContent = this.contido.replace(/\+/g, ' ')
      return decodeURIComponent(parseddContent)
    }
  }
})
